import request from '@/utils/request'

/** 登录：后端已排除 JWT/签名拦截，无需 Authorization / X-Sign */
export function login(data) {
  return request({
    url: '/sys-user/login',
    method: 'post',
    data,
    // 标记为公开接口，request 拦截器不附加鉴权头
    skipAuth: true
  })
}

/**
 * 退出登录：需携带 JWT + 签名。
 * 后端根据 ThreadLocal 中的用户删除 Redis 登录信息。
 */
export function logout() {
  return request({
    url: '/sys-user/logout',
    method: 'post'
  })
}
